module.exports = __webpack_public_path__ + "assets/images/speechbubble.svg";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/speechbubble.svg
// module id = 500
// module chunks = 0